import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../utils/helpers';
import { SkeletonStats24h } from '../SkeletonTradeRow/SkeletonTradeRow';
import './Stats24h.css';

function Stats24h({ summary }) {
  const { t } = useTranslation();

  if (!summary) {
    return <SkeletonStats24h />;
  }

  // Get 24h stats from summary (based on DB data, not filtered client data)
  const totalVolume24h = summary?.whaleTrades?.totalVolume || 0;
  const totalLiquidations24h = summary?.liquidations?.totalVolume || 0;

  return (
    <div className="stats24h-grid">
      <div className="g-col-6">
        <div className="card">
          <div className="card-header">
            ⏳ {t('stats.liquidation24h')}
          </div>
          <div className="card-body pd pt-0 text-center" style={{ overflow: 'hidden' }}>
            <div className="number liquidation-number" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
              {formatNumber(totalLiquidations24h)}
            </div>
          </div>
        </div>
      </div>
      <div className="g-col-6">
        <div className="card">
          <div className="card-header">
            ⏳ {t('stats.volume24h')}
          </div>
          <div className="card-body pd pt-0 text-center" style={{ overflow: 'hidden' }}>
            <div className="number volume-number" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
              {formatNumber(totalVolume24h)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stats24h;
